import { render, staticRenderFns } from "./audioBooks.vue?vue&type=template&id=64c8a08e&scoped=true&"
import script from "./audioBooks.vue?vue&type=script&lang=js&"
export * from "./audioBooks.vue?vue&type=script&lang=js&"
import style0 from "./audioBooks.vue?vue&type=style&index=0&id=64c8a08e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c8a08e",
  null
  
)

export default component.exports